(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mt-product-carousel')) {
  customElements.define('mt-product-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      if (this.slides.length < 2) return;
      this.abort = new AbortController();
      this.index = 0;
      this.hovered = false;
      this.focused = false;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      const options = { signal: this.abort.signal };
      this.querySelector('[data-controls]').hidden = false;
      this.querySelector('[data-prev]').addEventListener('click', () => this.manual(this.index - 1), options);
      this.querySelector('[data-next]').addEventListener('click', () => this.manual(this.index + 1), options);
      this.querySelectorAll('[data-dot]').forEach(button => button.addEventListener('click', () => this.manual(Number(button.dataset.dot)), options));
      this.querySelector('[data-pause]').addEventListener('click', () => {
        this.paused = !this.paused;
        this.updatePause();
        this.schedule();
      }, options);
      this.addEventListener('pointerenter', () => { this.hovered = true; this.schedule(); }, options);
      this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
      this.addEventListener('focusout', event => {
        if (!this.contains(event.relatedTarget)) { this.focused = false; this.schedule(); }
      }, options);
      this.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.manual(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', event => {
        if (event.matches) this.paused = true;
        this.updatePause();
        this.schedule();
      }, options);
      this.updatePause();
      this.preloadNext();
      this.schedule();
    }
    updatePause() {
      const button = this.querySelector('[data-pause]');
      button.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
      button.textContent = this.paused ? '▶' : 'Ⅱ';
    }
    manual(index) {
      this.paused = true;
      this.show(index);
      this.updatePause();
      this.querySelector('[data-status]').textContent = this.slides[this.index].querySelector('.mt-hero-caption').textContent.trim();
      this.schedule();
    }
    show(index) {
      const next = (index + this.slides.length) % this.slides.length;
      this.slides[this.index].hidden = true;
      this.slides[this.index].classList.remove('mt-slide-enter');
      this.index = next;
      this.slides[this.index].hidden = false;
      this.slides[this.index].classList.add('mt-slide-enter');
      this.querySelector('[data-current]').textContent = String(this.index + 1);
      this.querySelectorAll('[data-dot]').forEach((button, i) => button.setAttribute('aria-pressed', String(i === this.index)));
      this.preloadNext();
    }
    preloadNext() {
      const image = this.slides[(this.index + 1) % this.slides.length].querySelector('img');
      if (image) image.loading = 'eager';
    }
    schedule() {
      window.clearTimeout(this.timer);
      if (this.paused || this.hovered || this.focused || document.hidden) return;
      this.timer = window.setTimeout(() => { this.show(this.index + 1); this.schedule(); }, 5000);
    }
    disconnectedCallback() {
      window.clearTimeout(this.timer);
      this.abort?.abort();
      this.abort = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
